"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNextBestBaseWithDeliveryAddress = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const GetNextBestBase_1 = tslib_1.__importDefault(require("./GetNextBestBase"));
class GetNextBestBaseWithDeliveryAddress extends GetNextBestBase_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '1234AB_56_C',
        description: `Not used in retrieving the offer, but for the offer feedback.
Specify this field if you know the address, that will help with collecting feedback data.`,
    }),
    (0, class_transformer_1.Expose)({ name: 'delivery_address' }),
    (0, base_models_1.IsAddressKey)(),
    tslib_1.__metadata("design:type", String)
], GetNextBestBaseWithDeliveryAddress.prototype, "deliveryAddress", void 0);
exports.GetNextBestBaseWithDeliveryAddress = GetNextBestBaseWithDeliveryAddress;
